import { DeleteOutlined, EditOutlined, WhatsAppOutlined } from '@ant-design/icons';
import { Button, Card, Image, message, Popconfirm, Table, Tag } from 'antd';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ContentWithErrorHandler from '../../app/ContentWithErrorHandler';
import { basicSort, TableColumnTextFilterConfig } from '../../common/TableHelper';
import { useDeleteUmkmMutation, useGetAllUmkmQuery } from './umkmAPI';
import { Umkm } from './types';

function UmkmList() {
  const navigate = useNavigate();
  const { data, error, isLoading } = useGetAllUmkmQuery();
  const [deleteUmkm] = useDeleteUmkmMutation();

  const handleDelete = async (id: number) => {
    try {
      await deleteUmkm(id).unwrap();
      message.success('UMKM berhasil dihapus');
    } catch (error) {
      message.error('Gagal menghapus UMKM');
    }
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      sorter: (a: Umkm, b: Umkm) => basicSort(a.id, b.id),
      width: 80,
    },
    {
      title: 'Gambar',
      dataIndex: 'images',
      key: 'images',
      width: 100,
      render: (images: string[]) =>
        images && images.length > 0 ? <Image src={images[0]} width={60} height={60} style={{ objectFit: 'cover' }} /> : '-',
    },
    {
      title: 'Nama UMKM',
      dataIndex: 'name',
      key: 'name',
      sorter: (a: Umkm, b: Umkm) => basicSort(a.name, b.name),
      ...TableColumnTextFilterConfig<Umkm>('name'),
    },
    {
      title: 'Pemilik',
      dataIndex: ['owner', 'name'],
      key: 'owner',
      render: (ownerName: string) => ownerName || '-',
    },
    {
      title: 'Kategori',
      dataIndex: 'categories',
      key: 'categories',
      render: (categories: any[]) => (
        <>
          {categories?.map((cat) => (
            <Tag key={cat.id}>{cat.name}</Tag>
          ))}
        </>
      ),
    },
    {
      title: 'Alamat',
      dataIndex: 'address',
      key: 'address',
      ellipsis: true,
    },
    {
      title: 'WhatsApp',
      dataIndex: 'whatsappNumber',
      key: 'whatsappNumber',
      render: (phone: string) =>
        phone ? (
          <a href={`https://wa.me/${phone}`} target="_blank" rel="noopener noreferrer">
            <WhatsAppOutlined /> {phone}
          </a>
        ) : (
          '-'
        ),
    },
    {
      title: 'Aksi',
      key: 'action',
      width: 120,
      render: (record: Umkm) => (
        <div style={{ display: 'flex', gap: 8 }}>
          <Button type="primary" icon={<EditOutlined />} onClick={() => navigate(`edit/${record.id}`)} size="small" />
          <Popconfirm title="Yakin ingin menghapus UMKM ini?" onConfirm={() => handleDelete(record.id)} okText="Ya" cancelText="Tidak">
            <Button danger icon={<DeleteOutlined />} size="small" />
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <ContentWithErrorHandler isError={error} isLoading={isLoading}>
      <Card
        title="Data UMKM"
        size="small"
        extra={
          <Button style={{ borderRadius: 5 }}>
            <Link to="create">+ Tambah UMKM</Link>
          </Button>
        }
      >
        <Table columns={columns} dataSource={data} rowKey="id" scroll={{ x: 1200 }} />
      </Card>
    </ContentWithErrorHandler>
  );
}

export default UmkmList;
